import Form from "../../componets/Form";

export default function Section6() {
  return (
    <div className="mt-[-100px] md:mt-[0px]">
      <Form />
    </div>
  );
}
